<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>To Catch a Thief</title>
<link href="pdlmsr.css" rel="stylesheet" type="text/css"/>
<meta content="text/html; charset=UTF-8"/>
<link href="page-template.xpgt" rel="stylesheet" type="application/vnd.adobe-page-template+xml"/>
<div class="halfTitlePage" id="htl"><h2 class="halfTitlePageTitle"><span class="bold"><span><em class="italic"><span>TO CATCH A THIEF</span></em></span></span></h2></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tocatchathief_htl.vue?65af9d13